import { insert, without } from 'ramda'

import {
  MultiOptionItem,
  MultiOptionList
} from '@/components/multi-option-select'

import { handleDataLayerEvent } from './utils'

const BathRadioBar = ({ bathroom_count = [], updateFilters }) => {
  const handleUpdateFilters = id => {
    handleDataLayerEvent('bath')
    const count = bathroom_count || []
    const filter = count?.includes(id)
      ? without(id, count)
      : insert(0, id, count)
    const sortedFilter = filter.sort()
    return updateFilters({ bathroom_count: sortedFilter })
  }

  const OPTIONS = [
    {
      id: '1',
      label: '1'
    },
    {
      id: '2',
      label: '2'
    },
    {
      id: '3+',
      label: '3+'
    }
  ]

  return (
    <MultiOptionList>
      {OPTIONS.map(option => (
        <MultiOptionItem
          key={option.id}
          id={option.id}
          clickId={`search-filter-bath-${option.id}`}
          label={option.label}
          onClick={handleUpdateFilters}
          selected={bathroom_count?.includes(option.id) || false}
        />
      ))}
    </MultiOptionList>
  )
}

export default BathRadioBar
